export const languages = ["C/C++", "CSS","HTML", "Java","JavaScript", "Python"];

export const software = ["Atom", "Eclipse", "Figma", "git", "IntelliJ IDEA", "Pycharm", "VirtualBox", "WebStorm"];

export const frameworks = ["Bootstrap", "Material-UI"];

export const skills = [languages, software, frameworks];
